import StipendRequest from './models'

export default StipendRequest
